export const SeccionProfesional = ({ data }) => {
    return (
        <>
            {
                (data.length > 0) &&
                <>
                    <div style={{ fontWeight: 'bold', fontSize: '9pt' }}>
                        Datos de Profesionales
                    </div>
                    <table style={{width: '100%', borderCollapse: 'collapse', marginTop: '10px'}}>
                        <tr>
                            <td style={{border:'none', borderTopLeftRadius: '5px', borderCollapse: 'collapse', width:'70%', padding: '5px', color: '#fff', backgroundColor: '#636A73'}}>Nombre</td>
                            <td style={{border:'none', borderTopRightRadius: '5px', borderCollapse: 'collapse', width:'30%', padding: '5px', color: '#fff', backgroundColor: '#636A73', textAlign: 'right'}}>Tipo</td>
                        </tr>   
                        {data.map((profesional) => (
                            <tr>
                                <td style={{border:'none', borderCollapse: 'collapse', borderLeft: '1pt solid #dcdcdc', borderBottom: '1pt solid #dcdcdc'}}>{profesional.profesional}</td>
                                <td style={{border:'none', borderCollapse: 'collapse', borderRight: '1pt solid #dcdcdc', borderBottom: '1pt solid #dcdcdc', textAlign: 'right'}}>{profesional.tipo}</td>
                            </tr>
                        ))}        
                    </table>
                </>
            }
        </>
    )
}